import { Component, useMemo } from 'react';
import { Link } from 'react-router-dom';
import AccountSelect from './accountSelect'
import ReconnectError from './reconnect';
import { Collapse } from 'react-bootstrap'
import Switch from './switch'
import HTMLReactParser from 'html-react-parser';
import { getCurrentUrl, baseUrl, showAddAccountAlertNew } from '../../../../../utils';
import ConnectError from './connect';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import CustomToolTip from '../../../../CommonComponents/Tooltip';
import Uploader from '../../../../CommonComponents/ImageUploader';
import { uploadFeedProfileImage } from '../../../../../actions/manageFeedsAction';
import Author from '../../../../CommonComponents/Author/Author';

const currentUrl = getCurrentUrl();

const isProfileImgEditAble = (network, filterId) => {
    if (network == 18 || network == 2) {
        return [23, 34, 66, 1].includes(filterId);
    } else if (network == 10) {
        return [17, 1].includes(filterId);
    } else if (network == 3) {
        return [8, 1, 67, 65, 66].includes(filterId);
    } else if (network == 7) {
        return [1, 75].includes(filterId);
    } else if (network == 28) {
        return [2, 71].includes(filterId);
    } else if (network == 12) {
        return [13].includes(filterId);
    } else if (network == 5) {
        return [1, 71].includes(filterId);
    } else if (network == 1 || network == 8 || network == 6 || network == 11) {
        return [1].includes(filterId);
    }
    return false;
}
export default class FeedsRecord extends Component {
    constructor(props) {
        super(props)
        const { feed } = this.props;
        const { moderation, status } = feed || {};
        this.state = {
            moderation: moderation,
            status: status,
            width: window.innerWidth,
            activeRow: 0
        }
    }

    handleResize = () => this.setState({ width: window.innerWidth });

    componentDidMount() {
        const { feed } = this.props
        this.setState({ status: feed.status, moderation: feed.moderation }, this.handleResize);
        window.addEventListener('resize', this.handleResize);
    }

    onModerationSwitch = (status) => {
        const { feed, changeStatus } = this.props
        changeStatus(feed.id, Number(status), 'moderation')
        this.setState({ moderation: Number(status) })
    }

    onFeedStatusSwitch = (status) => {
        const { feed, changeStatus } = this.props
        changeStatus(feed.id, Number(status), 'status', feed.postCount)
        this.setState({ status: Number(status) })
    }

    reconnectAccount = (obj, status = 0) => {
        const item = {
            id: obj.networkId,
            name: (obj.networkName).toLowerCase()
        }
        localStorage.setItem("feed_id", obj.id);
        localStorage.setItem('refresh', status);
        showAddAccountAlertNew(item, "manageFeed");
    }

    getRecord = (id) => {
        const { activeRow } = this.state
        this.setState({ activeRow: activeRow ? 0 : id })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    render() {
        const { feed, onFeedDelete, changeAccount, getFeed } = this.props
        const { status, moderation, activeRow } = this.state;
        const wallId = localStorage.getItem("wallId");
        const feedName = HTMLReactParser(feed.networkId == 29 ? feed.name === 'onsiteupload' ? 'SnapUp' : feed.name : feed.name);
        return (
            <>  <table className='table table-hover dataTable mb-0'>
                <tbody>
                    <tr className={`${activeRow ? 'row_open' : ''} feed_row`} key={feed.id} id={`feedsrecord${feed.id}`}>
                        <td onClick={() => this.state.width < 768 ? this.getRecord(feed.id) : null} className="text-nowrap feed_status__ inactive_feed">
                            <div className="d-flex align-items-center flex-lg-nowrap flex-wrap justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 me-4 mt-lg-0 d-flex align-items-center">
                                        <div className="symbol symbol-30">
                                            <img className="img-fluid" src={baseUrl(`social-icons-feed/${feed.socialIcon == "fa-twitter" ? feed.socialIcon + "X" : feed.socialIcon}.svg`)} height={30} width={30} alt={feed.networkName} />
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column text-left overflow-hidden me-2">
                                        <p className="text-dark m-0 d-flex">
                                            <CustomToolTip placement="right" overlayText={feedName}>
                                                <strong className="text-nowrap overflow-hidden text-ellipsis" style={{ maxWidth: "170px" }}>
                                                    {feedName}
                                                </strong>
                                            </CustomToolTip>

                                            {feed?.socialLink ?
                                                <CustomToolTip placement="right" overlayText={feed?.tooltip || ''}>
                                                    <a href={feed.networkId !== 8 ? feed.socialLink : `https://vimeo.com/user${feed.accountId}`} target="_blank">
                                                        <i className="fas fa-external-link-alt icon-nm ms-1"></i>
                                                    </a>
                                                </CustomToolTip> : null}
                                        </p>
                                        <p className="font-weight-normal text-muted mb-0 text-nowrap">
                                            {feed.networkId == 2 ? "By Instagram" : feed.networkId == 18 ? "By Facebook" : feed.networkName}
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex align-items-center reconnect" data-test-id={`connect-${feed.networkName}-${feedName}`}>
                                        {feed.isBtntext == "" && feed.cronStatus != "" ?
                                            <span onClick={() => this.reconnectAccount(feed, 0)}>
                                                <ConnectError msg={feed.cronStatus} showMsg={true} />
                                            </span>
                                            : ''}
                                        {feed.isBtntext == "Reconnect" ?
                                            <span onClick={() => this.reconnectAccount(feed, 1)}>
                                                <ReconnectError msg={feed.cronStatus} />
                                            </span>
                                            : ''}
                                        {feed.isBtntext == "Connect" ?
                                            <span onClick={() => this.reconnectAccount(feed, 0)}>
                                                <ConnectError msg={feed.cronStatus} showMsg={false} />
                                            </span>
                                            : ''}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td className="feed_status__ inactive_feed mobileHide text-center">
                            <span className='d-flex justify-content-center'>
                                <UploadComponent {...{ feed, getFeed }} />
                            </span>
                        </td>
                        <td className="feed_status__ inactive_feed user_row__ feed-select mobileHide text-center">

                            {feed && feed.accountList && feed.accountList.length ?
                                feed.filterId && [1, 2, 3, 4, 5, 8, 65, 67, 26, 34, 25, 66].includes(feed.filterId) ?
                                    feed.accountList.filter(x => x.id == feed.connectedAccount) ? <AccountSelect changeAccount={changeAccount} feed={feed} key={feed.id} />
                                        : '--'
                                    : '--'
                                : '--'}
                        </td>
                        <td className="justify-content-center toggleOnBut feed_status__ inactive_feed mobileHide">
                            {this.state.width >= 768 ?
                                <Switch value={moderation} setValue={e => this.onModerationSwitch(e)} id={`moderationSwitch_${feed.id}`} dataAtt={`mod-${feed.networkName}-${feedName}`} /> : null}
                        </td>
                        <td className="feed_status__ inactive_feed mobileHide">
                            <div className="text-center">
                                <Link to={`/moderation/index/${wallId}/feed/${feed.id}`}>
                                    <p className="text-dark m-0 text-nowrap">
                                        <strong>{feed.postCount}</strong>
                                    </p>
                                    <p className="font-weight-normal text-muted mb-0 text-nowrap">
                                        Approved {feed.postCount > 1 ? 'Posts' : 'Post'}
                                    </p></Link>
                            </div>
                        </td>
                        <td className="justify-content-center toggleOnBut mobileHide">
                            {this.state.width >= 768 ?
                                <Switch value={status} setValue={e => this.onFeedStatusSwitch(e)} id={`FeedStatusSwitch${feed.id}`} dataAtt={`status-${feed.networkName}-${feedName}`} /> : null}
                        </td>
                        <td className="text-center mobileHide">
                            <button className="btn btn-link btn-icon btn-sm btn-clean maintainPopUp resetAction delete tbl-action-btn" title="delete" onClick={() => onFeedDelete(feed.id, feed.postCount)} data-test-id={`del-${feed.networkName}-${feedName}`}>
                                <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'fs-6'} />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
                {this.state.width < 768 ?
                    <Collapse in={activeRow == feed.id ? true : false}>
                        <div>
                            <table className='table mb-0 table-borderless body-bg'>
                                <tbody>
                                    <tr>
                                        <td className='border-0'>
                                            <span className="dtr-title">Account:</span>
                                        </td>
                                        <td className='border-0'>
                                            <span className='dtr-data'>
                                                {feed && feed.accountList && feed.accountList.length ?
                                                    feed.filterId && [1, 2, 3, 4, 5, 8, 65, 67, 26].includes(feed.filterId) && feed.networkId != 2 ?
                                                        feed.accountList.filter(x => x.id == feed.connectedAccount) ? <AccountSelect changeAccount={changeAccount} feed={feed} key={feed.id} /> : '--'
                                                        : '--'
                                                    : '--'}
                                            </span>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td className='border-0'><span className="dtr-title">Profile Pic:</span></td>
                                        <td className='border-0'>
                                            <span className='d-inline-block'>
                                                <UploadComponent {...{ feed }} />
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='border-0'><span className="dtr-title">Moderation:</span></td>
                                        <td className='border-0'><Switch value={moderation} setValue={e => this.onModerationSwitch(e)} id={`moderationSwitch_${feed.id}`} dataAtt={`mod-${feed.networkName}-${feedName}`} /></td>
                                    </tr>
                                    <tr>
                                        <td className='border-0'><span className="dtr-title">Posts:</span></td>
                                        <td className='border-0'>
                                            <span className='dtr-data'>
                                                <div className='text-center'>
                                                    <a className="text-dark" href={`${currentUrl}/moderation/index/${wallId}/feed/${feed.id}`} target="_blank">
                                                        <p className="text-dark m-0 text-nowrap">
                                                            <strong>{feed.postCount}</strong>
                                                        </p>
                                                        <p className="font-weight-normal text-muted mb-0 text-nowrap">
                                                            Approved {feed.postCount > 1 ? 'Posts' : 'Post'}
                                                        </p>
                                                    </a>
                                                </div>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='border-0'><span className="dtr-title">Status:</span></td>
                                        <td className='border-0'><Switch value={status} setValue={e => this.onFeedStatusSwitch(e)} id={`FeedStatusSwitch${feed.id}`} dataAtt={`mod-${feed.networkName}-${feedName}`} /></td>
                                    </tr>
                                    <tr>
                                        <td className='border-0'><span className="dtr-title">Action:</span></td>
                                        <td className='border-0'>
                                            
                                            <span className='dtr-data d-inline-block'>
                                                <button className="btn btn-link btn-icon btn-sm btn-clean maintainPopUp resetAction delete tbl-action-btn" title="delete" onClick={() => onFeedDelete(feed.id)}>
                                                    <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'fs-6'} />
                                                </button>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Collapse> : null}

            </>
        )
    }
}

const UploadComponent = ({ feed, getFeed }) => {
    const wallId = localStorage.getItem("wallId");
    const uploadPath = `media/${localStorage.getItem("ownerId")}/${wallId}/${feed.id}`;

    const canEditProfile = useMemo(() => {
        const { networkId, filterId } = feed;
        return (filterId && networkId) ? isProfileImgEditAble(networkId, filterId) : false;
    }, [feed]);

    return canEditProfile ?
        <Uploader uploadPath={uploadPath} uploadAgents={[]} onImgUpload={(path) => uploadFeedProfileImage(path, feed.id, getFeed)}>
            <CustomToolTip placement="top" className="dark" overlayText='Update Profile Picture'>
                {/* <button className="btn btn-link btn-icon btn-sm btn-clean maintainPopUp resetAction delete tbl-action-btn">
                    <span className="svg-icon-lg svg-icon-dark">
                        <i className="fa fa-pencil fs-6 me-0"></i>
                    </span>
                </button> */}
                <div className="position-relative">
                    <Author imageSize={36}
                        symbolClass={'symbol-36 f-center text-white fs-5'} className={'symbol-36 rounded-circle flex-shrink-0 border overflow-hidden object-fit-cover'}
                        name={feed.name?.replace('@', '') || ''} profileUrl={feed.profile_picture} networkId={feed.networkId} />
                    <span className="position-absolute bg-gray-200 rounded-circle d-flex align-items-center justify-content-center" style={{ top: -2, right: 2, width: 18, height: 18 }}>
                        <FontAwesomeIcon type="solid" icon={'pen'} iconClass="fs-10 text-gray-700 m-0" style={{ fontSize: 8 }} />
                    </span>
                </div>
            </CustomToolTip>
        </Uploader> : null
}